import React, { useState } from 'react';

export default function NoteEditor({ zone, category, existing, onSave, onClose, onDelete }) {
  const [value, setValue] = useState(existing?.note || '');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(zone, category, value.trim());
  };

  const label = [zone, category].filter(Boolean).join(' › ') || 'General';

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3 className="modal-title">Nota — {label}</h3>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <textarea
              autoFocus
              className="input"
              value={value}
              onChange={e => setValue(e.target.value)}
              placeholder="Escribí la nota acá... (ej: FBT reemplazado por Opera D12, falta cable XLR)"
              rows={4}
              style={{ resize: 'vertical' }}
            />
          </div>

          <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
            {existing && onDelete && (
              <button
                type="button"
                className="btn btn-ghost"
                style={{ marginRight: 'auto', color: 'var(--danger, #e53e3e)' }}
                onClick={() => { onDelete(zone, category); onClose(); }}
              >
                Borrar nota
              </button>
            )}
            <button type="button" className="btn btn-ghost" onClick={onClose}>Cancelar</button>
            <button type="submit" className="btn btn-primary">Guardar nota</button>
          </div>
        </form>
      </div>
    </div>
  );
}
